<template>
    <div
        class="check-button-container"
        v-bind="$attrs"
        v-on="$listeners"
        :class="[value ? 'checked' : 'unChecked']"
        :style="{ height: iconSize + 'px', width: iconSize + 'px', backgroundSize: iconSize + 'px' }"
    ></div>
</template>

<script>
export default {
    name: 'CheckButton',
    props: {
        iconSize: {
            type: Number,
            default: () => 16,
        },
        value: {
            type: Boolean,
            default: () => false,
        },
    },
}
</script>

<style lang="less" scoped>
.check-button-container {
    display: inline-block;
}

.checked {
    background: url('~@/assets/img/agree.png') no-repeat;
}

.unChecked {
    background: url('~@/assets/img/dis_agree.png') no-repeat;
}
</style>
